import { useEffect, useState } from 'react';
import cfg from '../config/design-update.json';
import { useNotice } from './notices';
import { useAuthStore } from '../stores/authStore';

/**
 * Temporary "new look / Bookmarks" announcement: top strip, info icons and the FAQ entry.
 * Everything switches off by itself at cfg.expiresAt (config/design-update.json, Europe/Zurich).
 * Test hook: localStorage gbr_test_now = ISO time pretends it is that moment.
 */
export const DESIGN_UPDATE_ID = cfg.id;
export const DESIGN_UPDATE_FAQ = `/faq#${cfg.id}`;

const EVT = 'gbr-design-update-closed';

const now = () => {
  try {
    const t = Date.parse(localStorage.getItem('gbr_test_now') || '');
    if (!Number.isNaN(t)) return t;
  } catch { /* ignore */ }
  return Date.now();
};
export const designUpdateExpired = () => now() >= Date.parse(cfg.expiresAt);

/** Strip and icons share one dismissal: closing the strip hides the icons too. */
export function useDesignUpdate() {
  const { visible, dismiss: close } = useNotice(cfg.id);
  const [expired, setExpired] = useState(designUpdateExpired());
  const [closed, setClosed] = useState(false);
  useEffect(() => {
    const on = () => setClosed(true);
    window.addEventListener(EVT, on);
    return () => window.removeEventListener(EVT, on);
  }, []);
  const dismiss = () => {
    close();
    window.dispatchEvent(new Event(EVT)); // every instance (strip, icons) hides at once
  };
  useEffect(() => {
    if (expired) return;
    const ms = Date.parse(cfg.expiresAt) - now();
    const t = setTimeout(() => setExpired(true), Math.min(Math.max(ms, 0), 2 ** 31 - 1));
    return () => clearTimeout(t);
  }, [expired]);
  // announcement is for existing members (they knew "Credits"); guests never see it
  const member = useAuthStore((s) => s.isAuthenticated);
  return { show: member && visible && !closed && !expired, dismiss };
}
